import { QueryErrorBoundary } from '@/catalog-apps/components/QueryErrorBoundary'
import { LoadingComponent } from '@/components/ui/LoadingComponent'
import { Suspense, useState } from 'react'
import { SubscriptionsBreadcrumb } from '../SubscriptionBreadcrumbs'
import { TablePageContainer } from '@/components/ui/DataTable/PageTableContainer'
import { DataTable } from '@/components/ui/DataTable'
import { IconPlusOutline } from '@icons/IconPlusOutline'
import { Button } from '@/components/shadcn/button'
import { OrgProjectForm } from '../Forms/OrgProjectForm'
import { useRestClient } from '@/contexts/QueryProvider'
import { useSessionStorage } from '@/hooks'
import { isPlatformAdmin, isProjectLeader, isSuperUser } from '@/util'
import { useCurrentOrganisation } from '../useCurrentOrganisation'
import { columns } from './OrganisationProjectsTable/orgProjectsTableColumns'

export function OrganisationProjectsPage() {
  return (
    <>
      <SubscriptionsBreadcrumb title="Projects" />
      <QueryErrorBoundary errorMessage="Failed to fetch organisation">
        <Suspense fallback={<LoadingComponent className="flex-1" />}>
          <OrganisationProjectsPanelContent />
        </Suspense>
      </QueryErrorBoundary>
    </>
  )
}

function OrganisationProjectsPanelContent() {
  const { id: orgId } = useCurrentOrganisation()
  const { getProjectsApiListOrganisationProjects } = useRestClient()

  const [userRole] = useSessionStorage('roles', 1)
  const [isAddProjectAllowed] = useState(() => {
    return isPlatformAdmin(userRole) || isSuperUser(userRole) || isProjectLeader(userRole)
  })

  const { data: organisationProjects } = getProjectsApiListOrganisationProjects.useSuspenseQuery({
    query: {
      orgId,
    },
  })

  return (
    <TablePageContainer>
      <DataTable
        columns={columns}
        data={organisationProjects}
        action={
          <OrgProjectForm
            sheetTitle="Create a new project"
            sheetTrigger={
              <Button disabled={!isAddProjectAllowed} size="lg" variant="outline">
                <IconPlusOutline className="mr-2" />
                Create new project
              </Button>
            }
          />
        }
      />
    </TablePageContainer>
  )
}
